import { render, staticRenderFns } from "./VentasInsumo.vue?vue&type=template&id=e3125dbc"
import script from "./VentasInsumo.vue?vue&type=script&lang=js"
export * from "./VentasInsumo.vue?vue&type=script&lang=js"
import style0 from "./VentasInsumo.vue?vue&type=style&index=0&id=e3125dbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports